<template>
  <div>
    <DataTableWrapper
      ref="tableWrapper"
      :initialSortBy="[{ field: 'createdAt', dir: 'desc' }]"
      :data-source="{
        type: 'AxisGQL',
        query: require('@/services/gql/types/Files/queries/files.gql')
      }"
      :headers="$options.headersConfig"
      :filters="{
        fileName: { control: 'text', modifier: 'contains' },
        type: {
          control: 'select',
          options: $options.mediaFileTypes,
          dataType: String
        },
        createdAt: { control: 'date-range' }
      }"
      @query-state-updated="getStateQuery"
    >
      <template v-slot="{ tableProps, tableListeners, filtersProps, filtersListeners }">
        <v-data-table
          fixed-header
          height="80vh"
          :items-per-page="$options.perPage.itemsPerPage"
          :footer-props="{ itemsPerPageOptions: $options.perPage.itemsPerPageOptions }"
          v-bind="tableProps"
          v-on="tableListeners"
          v-model="mixSelectedItems"
        >
          <template v-for="(h, i) in $options.headersConfig" v-slot:[`header.${h.value}`]>
            <v-tooltip open-delay="350" :key="i" bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ h.text }}
                </span>
              </template>
              <span>{{ h.description }}</span>
            </v-tooltip>
          </template>
          <template v-slot:[`body.prepend`]="{}">
            <DataTableFilters
              is-grid-selectable
              v-bind="filtersProps"
              v-on="filtersListeners"
            />
          </template>
          <template
            v-for="(h, i) in $options.headersConfig"
            v-slot:[`item.${h.value}`]="{ item }"
          >
            <div :key="i">
              <div v-if="h.type === 'number' && item[h.value] !== null">
                {{ formatAmount(item[h.value]) }}
              </div>
              <div v-else-if="h.text === 'Имя файла'">
                <router-link
                  title="Редактировать"
                  :to="{
                    name: 'page-file',
                    params: { id: item.id }
                  }"
                  >{{ item[h.value] }}</router-link
                >
              </div>
              <div v-else-if="h.type === 'date'">
                <DateTimeCell :value="item[h.value]" />
              </div>
              <div v-else-if="h.type === 'media'">
                <!--                <img :src="item.url" :alt="item.altText" style="width: 160px">-->
                <v-col>
                  <component
                    hide-delete
                    width="150"
                    :is="`MediaPreview${item.type}`"
                    :file="item"
                    @choose-file="previewFileHandler(item)"
                  />
                </v-col>
              </div>
              <div v-else-if="h.type === 'boolean'">
                <v-icon
                  v-text="'mdi-checkbox-marked-circle'"
                  :color="item[h.value] ? 'success' : 'grey'"
                />
              </div>
              <div v-else-if="h.type === 'actions'">
                <v-tooltip open-delay="250" top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="
                        $router.push({
                          name: 'page-file',
                          params: { id: item.id }
                        })
                      "
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Редактировать</span>
                </v-tooltip>
                <v-tooltip open-delay="250" top>
                  <template #activator="{ on, attrs }">
                    <v-btn
                      icon
                      v-bind="attrs"
                      v-on="on"
                      @click="deleteMediaFile(item.id)"
                    >
                      <v-icon color="red">mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Удалить</span>
                </v-tooltip>
              </div>
              <div v-else>
                {{ item[h.value] }}
              </div>
            </div>
          </template>
        </v-data-table>
      </template>
    </DataTableWrapper>
    <ConfirmationDialog ref="confirm" confirmText="Удалить" />
    <PreviewDialog
      v-if="chosenFile !== null"
      ref="previewDialog"
      :file="chosenFile"
      @close="chosenFile = null"
    />
  </div>
</template>

<script>
import ConfirmationDialog from '@/components/confirmation-dialog'
import { formatAmount } from '@/utils'
import perPage from '@/configs/v-data-table.js'
import headersConfig from './headersConfig.js'
import DataTableWrapper from '@/components/data-table-wrapper'
import DataTableFilters from '@/components/data-table-filters'
import DateTimeCell from '@/components/date-time-cell'
import { paramsToListQueryInput } from '@/components/data-table-wrapper/data-sources/axis-gql/utils'
import deleteFileMutation from '@/services/gql/types/Files/mutations/deleteFile.gql'
import { gridDependentMixin } from '@/pages/grid-dependent.mix'
import MediaPreviewAUDIO from '@/components/media-file-preview/types/media-preview-AUDIO'
import MediaPreviewIMAGE from '@/components/media-file-preview/types/media-preview-IMAGE'
import MediaPreviewVIDEO from '@/components/media-file-preview/types/media-preview-VIDEO'
import PreviewDialog from '@/components/media-file-preview/dialog/PreviewDialog'
import { filteredMediaTypes } from '@/configs/mediaFileTypes'

export default {
  name: 'GridMediaLibrary',
  gridType: 'mediaLibrary',
  perPage,
  headersConfig,
  mediaFileTypes: filteredMediaTypes('ALL'),
  props: {
    items: {
      type: Array,
      default: null
    }
  },
  mixins: [gridDependentMixin],
  components: {
    PreviewDialog,
    DataTableWrapper,
    DataTableFilters,
    DateTimeCell,
    ConfirmationDialog,
    MediaPreviewAUDIO,
    MediaPreviewIMAGE,
    MediaPreviewVIDEO
  },
  data () {
    return {
      queryState: null,
      chosenFile: null
    }
  },
  methods: {
    formatAmount,
    previewFileHandler (file) {
      this.chosenFile = file
    },
    getStateQuery (state) {
      this.queryState = paramsToListQueryInput(state)
    },
    refetch () {
      this.$refs.tableWrapper.refresh()
    },
    async deleteMediaFile (id) {
      try {
        await this.$refs.confirm.open()
        await this.$async.deleteFile.$perform({ id: Number(id) })
        this.$successMsg('Файл удален')
        this.refetch()
      } catch (e) {
        if (e.cancel) return
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении файла с ID ${id}`)
      }
    }
  },
  async: {
    deleteFile (variables) {
      return this.$apollo.mutate({
        mutation: deleteFileMutation,
        variables
      })
    }
  }
}
</script>
